import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Home } from './pages/Home';
import { Events } from './pages/Events';
import { Blog } from './pages/Blog';
import { BlogDetails } from './pages/BlogDetails';
import { Book } from './pages/Book';
import { Services } from './pages/Services';
import { About } from './pages/About';
import { SeeOurWorks } from './pages/SeeOurWorks';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0">
      <Routes location={location} key={location.pathname} data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<About data-id="element-5" />} data-id="element-4" />
        <Route path="/events" element={<Events data-id="element-7" />} data-id="element-6" />
        <Route path="/services" element={<Services data-id="element-9" />} data-id="element-8" />
        <Route path="/blog" element={<Blog data-id="element-11" />} data-id="element-10" />
        <Route path="/blog/:id" element={<BlogDetails data-id="element-13" />} data-id="element-12" />
        <Route path="/book" element={<Book data-id="element-15" />} data-id="element-14" />
        <Route path="/works" element={<SeeOurWorks data-id="element-17" />} data-id="element-16" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <BrowserRouter data-id="element-18">
      <ScrollToTop data-id="element-19" />
      <div className="w-full h-full" data-id="element-20">
        <AnimatedRoutes data-id="element-21" />
      </div>
    </BrowserRouter>;
}